export default __webpack_public_path__ + "static/media/arrow_up.7b5df8fd.svg";